/* Ausgelagert aus sections/smelu-pdp-hero.liquid am 26.08.2026.
   Grund: die Section lag bei 269 KB und Shopify nimmt nur 256 KB.
   Inhalt unveraendert, nur die eine Liquid-Zeile (section.id) laeuft jetzt
   ueber den vorhandenen Fallback-Selektor .smelu-pdp. */

          (function () {
            function boot() {
            var root = document.querySelector('.smelu-pdp');
            if (!root) return;

            var bar   = root.querySelector('[data-smelu-sticky-atc]')
                     || document.querySelector('[data-smelu-sticky-atc]');
            var btn   = bar && bar.querySelector('[data-smelu-sticky-atc-btn]');
            var buy   = root.querySelector('#kaufen');
            var form  = root.querySelector('[data-pdp-form]');
            if (!bar || !btn || !buy || !form) return;

            /* --- WICHTIG: Bar an den <body> hängen.
                   Innerhalb der Section liegen overflow:clip- und transform-
                   Container, beide brechen position:fixed (der Fixed-Kontext
                   wird dann der Vorfahre, nicht der Viewport). Am body ist sie
                   garantiert viewport-fixed und wird nicht geclippt. --- */
            document.body.appendChild(bar);

            /* --- Sichtbarkeit: nur wenn der Kaufbereich NACH OBEN raus ist.
                   Scrollt man wieder hoch (oder ist noch darüber), bleibt sie weg. --- */
            var shown = false;
            function setShown(next) {
              if (next === shown) return;
              shown = next;
              /* Rabatt-FAB (Pfannkuchen, unten links) weicht der Leiste —
                 sobald sie wieder verschwindet, kommt er zurück. */
              document.documentElement.classList.toggle('smelu-atc-bar-visible', next);
              if (next) {
                bar.hidden = false;
                requestAnimationFrame(function () { bar.classList.add('is-visible'); });
              } else {
                bar.classList.remove('is-visible');
                setTimeout(function () { if (!shown) bar.hidden = true; }, 300);
              }
            }

            /* Scroll-basiert statt IntersectionObserver: funktioniert auch mit
               Lenis-Smoothscroll zuverlässig und ist gegen Layout-Shifts robust. */
            var ticking = false;
            function check() {
              ticking = false;
              setShown(buy.getBoundingClientRect().bottom < 0);
            }
            function onScroll() {
              if (ticking) return;
              ticking = true;
              requestAnimationFrame(check);
            }

            window.addEventListener('scroll', onScroll, { passive: true });
            window.addEventListener('resize', onScroll, { passive: true });
            check();

            /* --- Klick → Kauf-Frame. Anker ist der Lieferzeit-Hinweis:
                   er soll gerade noch am unteren Rand stehen. Damit liegen
                   Titel, Preis, Farbe und ATC-Button alle im Bild.
                   Fallback (kein Lieferhinweis): Titel oben ausrichten. --- */
            var deliveryEl = root.querySelector('[data-pdp-delivery]');
            var titleEl    = root.querySelector('.smelu-pdp__titlewrap')
                          || root.querySelector('.smelu-pdp__title')
                          || buy;

            function targetTop() {
              var header = document.querySelector('.smelu-header, header.header, .shopify-section-header');
              var headH  = header ? header.getBoundingClientRect().height : 0;
              var y      = window.pageYOffset;

              if (deliveryEl) {
                var bottom = deliveryEl.getBoundingClientRect().bottom + y;
                return Math.max(0, bottom - window.innerHeight + 20);  /* 20px Luft unten */
              }
              return Math.max(0, titleEl.getBoundingClientRect().top + y - headH - 12);
            }

            btn.addEventListener('click', function () {
              if (btn.disabled) return;
              var top  = targetTop();
              var anim = window.__smeluAnim;
              if (anim && anim.lenis && typeof anim.lenis.scrollTo === 'function') {
                anim.lenis.scrollTo(top, { duration: 1.0 });
              } else {
                window.scrollTo({ top: top, behavior: 'smooth' });
              }
            });

            /* --- Preis spiegeln: das Varianten-JS oben schreibt in
                   [data-pdp-price-current] / [data-pdp-price-compare]. --- */
            var srcPrice   = root.querySelector('[data-pdp-price-current]');
            var srcCompare = root.querySelector('[data-pdp-price-compare]');
            var outPrice   = bar.querySelector('[data-sticky-price]');
            var outCompare = bar.querySelector('[data-sticky-compare]');

            function syncPrice() {
              if (srcPrice && outPrice) outPrice.textContent = srcPrice.textContent;
              if (outCompare) {
                var val = srcCompare ? srcCompare.textContent.trim() : '';
                outCompare.textContent = val;
                outCompare.hidden = !val;
              }
            }
            if (srcPrice && 'MutationObserver' in window) {
              var mo = new MutationObserver(syncPrice);
              mo.observe(srcPrice, { childList: true, characterData: true, subtree: true });
              if (srcCompare) mo.observe(srcCompare, { childList: true, characterData: true, subtree: true });
            }

            /* --- Ausverkauft-Status vom Haupt-Button übernehmen --- */
            var srcAtc = root.querySelector('[data-pdp-atc]');
            var outLbl = bar.querySelector('[data-smelu-sticky-atc-label]');
            if (srcAtc && 'MutationObserver' in window) {
              new MutationObserver(function () {
                btn.disabled = srcAtc.disabled;
                var lbl = srcAtc.querySelector('[data-pdp-atc-label]');
                if (lbl && outLbl) outLbl.textContent = lbl.textContent.trim();
              }).observe(srcAtc, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true });
            }

            console.log('[Smelu] Sticky-ATC aktiv');
            }

            if (document.readyState === 'loading') {
              document.addEventListener('DOMContentLoaded', boot);
            } else {
              boot();
            }
          })();
        

/* ---------------------------------------- */

  /* Bundle-Mengen-Widget Handler
     - Tier-Radio steuert die ausgewählte Bestellmenge
     - Beim Submit: cart/add.js mit N Line-Items (variant-IDs der Per-Unit-Picker)
     - Anschließend Redirect auf /discount/CODE?redirect=/cart damit der Rabatt automatisch greift */
  (function () {
    var bundle = document.querySelector('[data-pdp-bundle]');
    if (!bundle) return;
    var form = document.querySelector('[data-pdp-form]');
    if (!form) return;

    var atcBtn  = form.querySelector('[data-pdp-atc]');
    var atcLbl  = form.querySelector('[data-pdp-atc-label]');
    var qtyHidden = form.querySelector('[data-pdp-qty]');
    var variantHidden = form.querySelector('[data-pdp-variant-id]');
    var tiers = bundle.querySelectorAll('.smelu-pdp__bundle-tier');
    var radios = bundle.querySelectorAll('[data-pdp-bundle-radio]');

    var baseLabel = (atcLbl && atcLbl.textContent || 'In den Warenkorb').trim();

    function getSelectedTierEl() {
      for (var i = 0; i < tiers.length; i++) {
        if (tiers[i].classList.contains('is-selected')) return tiers[i];
      }
      return tiers[0];
    }

    function refreshLabel() {
      if (!atcLbl) return;
      var el = getSelectedTierEl();
      var n = parseInt(el.dataset.tier, 10);
      var pct = parseInt(el.dataset.pct, 10);
      var txt = baseLabel;
      if (n > 1) {
        txt = n + '× ' + baseLabel;
        if (pct > 0) txt += ' (−' + pct + ' %)';
      }
      atcLbl.textContent = txt;
    }

    function selectTier(tierEl) {
      tiers.forEach(function (t) { t.classList.remove('is-selected'); });
      tierEl.classList.add('is-selected');
      /* Hidden quantity sync (Standard-Form-Fallback wenn Cart-API down) */
      if (qtyHidden) qtyHidden.value = tierEl.dataset.tier;
      refreshLabel();
    }

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        var tierEl = r.closest('.smelu-pdp__bundle-tier');
        if (tierEl) selectTier(tierEl);
      });
    });

    /* Auch Click aufs Tier-Element (außerhalb Radio) soll auswählen */
    tiers.forEach(function (t) {
      t.addEventListener('click', function (e) {
        if (e.target.matches('select, option')) return;  /* Picker nicht stören */
        var radio = t.querySelector('[data-pdp-bundle-radio]');
        if (radio && !radio.checked) {
          radio.checked = true;
          selectTier(t);
        }
      });
    });

    /* Submit-Handler, überschreibt Standard-Form-Submit */
    form.addEventListener('submit', function (e) {
      var tierEl = getSelectedTierEl();
      var n = parseInt(tierEl.dataset.tier, 10);
      var code = (tierEl.dataset.code || '').trim();

      /* Tier 1 ohne Rabatt + ohne Picker → normaler Form-Submit reicht */
      if (n === 1 && !code) {
        if (qtyHidden) qtyHidden.value = '1';
        return;  /* Standard-Submit läuft durch */
      }

      e.preventDefault();
      if (atcBtn) {
        atcBtn.disabled = true;
        atcBtn.classList.add('is-loading');
      }

      /* Sammle variant-IDs: per-unit-picker oder fallback auf current variant */
      var items = [];
      var pickers = tierEl.querySelectorAll('[data-bundle-unit]');
      if (pickers.length === n) {
        pickers.forEach(function (p) {
          items.push({ id: parseInt(p.value, 10), quantity: 1 });
        });
      } else {
        /* Kein Variant-Set vorhanden → N× selbe Variant */
        var vid = variantHidden ? parseInt(variantHidden.value, 10) : null;
        for (var i = 0; i < n; i++) items.push({ id: vid, quantity: 1 });
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function (res) {
        if (!res.ok) throw new Error('add.js failed');
        return res.json();
      })
      .then(function () {
        /* Discount-URL holt den Code automatisch + redirected ins Cart */
        if (code) {
          window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (err) {
        console.error('[smelu-bundle]', err);
        if (atcBtn) { atcBtn.disabled = false; atcBtn.classList.remove('is-loading'); }
        /* Fallback: normale Form-Submit-Flow */
        form.submit();
      });
    });

    /* Initial label */
    refreshLabel();
  })();
  

/* ---------------------------------------- */

(function () {
  var root = document.querySelector('.smelu-fl');
  if (!root) return;

  var pills = root.querySelectorAll('.smelu-fl-pill');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        pills.forEach(function (p, i) {
          window.setTimeout(function () { p.classList.add('is-revealed'); }, i * 200);
        });
        io.disconnect();
      });
    }, { threshold: 0.3 });
    io.observe(root.querySelector('#smelu-fl-problems'));
  } else {
    pills.forEach(function (p) { p.classList.add('is-revealed'); });
  }

  var acts = root.querySelectorAll('.smelu-fl-act');
  var activeIdx = 0;
  function spotlight(i) {
    acts.forEach(function (a, idx) { a.classList.toggle('is-spotlight', idx === i); });
  }
  spotlight(activeIdx);

  var timer = window.setInterval(function () {
    activeIdx = (activeIdx + 1) % acts.length;
    spotlight(activeIdx);
  }, 2400);

  acts.forEach(function (a, i) {
    a.addEventListener('mouseenter', function () {
      window.clearInterval(timer);
      activeIdx = i;
      spotlight(activeIdx);
    });
    a.addEventListener('mouseleave', function () {
      window.clearInterval(timer);
      timer = window.setInterval(function () {
        activeIdx = (activeIdx + 1) % acts.length;
        spotlight(activeIdx);
      }, 2400);
    });
  });

  var safetyCards = root.querySelectorAll('.smelu-fl-safety-card');
  if ('IntersectionObserver' in window && safetyCards.length) {
    var io2 = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        safetyCards.forEach(function (c, i) {
          window.setTimeout(function () { c.classList.add('is-revealed'); }, i * 150);
        });
        io2.disconnect();
      });
    }, { threshold: 0.2 });
    io2.observe(root.querySelector('#smelu-fl-safety-cards'));
  } else {
    safetyCards.forEach(function (c) { c.classList.add('is-revealed'); });
  }

  var faqItems = root.querySelectorAll('.smelu-fl-faq-item');
  faqItems.forEach(function (item) {
    var btn = item.querySelector('.smelu-fl-faq-q');
    btn.addEventListener('click', function () {
      var open = item.classList.contains('is-open');
      faqItems.forEach(function (other) {
        other.classList.remove('is-open');
        other.querySelector('.smelu-fl-faq-q').setAttribute('aria-expanded', 'false');
      });
      if (!open) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  var speedsEl = root.querySelector('.smelu-fl__speeds');
  if (speedsEl) {
    var stDesc      = speedsEl.querySelector('#smelu-st-desc');
    var stChips     = speedsEl.querySelector('#smelu-st-chips');
    var stRpm       = speedsEl.querySelector('#smelu-st-rpm-label');
    var stPartLayer = speedsEl.querySelector('#smelu-st-particles');

    var SPEEDS = {
      1: { duration: '3.2s', vortex: 0.12, edge: 0.18, blur: 0,
           desc:  'Sanft, für flüssige Saucen und cremige Massen.',
           chips: ['Béchamel', 'Hollandaise', 'Crème anglaise', 'Pudding'],
           rpm:   'Stufe 1 · sanft kreisend' },
      2: { duration: '1.2s', vortex: 0.35, edge: 0.32, blur: 0.18,
           desc:  'Mittel, der Alltagsmodus für Suppen, Curries und Saucen.',
           chips: ['Bolognese', 'Curry', 'Suppe', 'Kompott'],
           rpm:   'Stufe 2 · gleichmäßig rührend' },
      3: { duration: '0.42s', vortex: 0.72, edge: 0.5, blur: 0.4,
           desc:  'Stark, für dicke Speisen, die Kraft brauchen.',
           chips: ['Risotto', 'Polenta', 'Grießbrei', 'Marmelade'],
           rpm:   'Stufe 3 · mit Kraft durchziehend' }
    };

    (function makeParticles() {
      stPartLayer.innerHTML = '';
      var items = [
        { color: '#A6B074',               minSz: 4, maxSz: 7 },
        { color: 'rgba(255,255,255,0.7)', minSz: 3, maxSz: 5 },
        { color: '#D9A857',               minSz: 3, maxSz: 5 }
      ];
      for (var i = 0; i < 11; i++) {
        var s = document.createElement('span');
        var kind = items[i % items.length];
        var r = 18 + Math.random() * 24;
        var angle = (i / 11) * Math.PI * 2 + Math.random() * 0.4;
        s.style.left = (50 + Math.cos(angle) * r) + '%';
        s.style.top  = (50 + Math.sin(angle) * r) + '%';
        var sz = kind.minSz + Math.random() * (kind.maxSz - kind.minSz);
        s.style.width  = sz + 'px';
        s.style.height = sz + 'px';
        s.style.background = kind.color;
        s.style.opacity = (0.55 + Math.random() * 0.4).toFixed(2);
        stPartLayer.appendChild(s);
      }
    })();

    function setSpeed(level) {
      var c = SPEEDS[level];
      if (!c) return;
      speedsEl.style.setProperty('--st-spin-duration', c.duration);
      speedsEl.style.setProperty('--st-vortex-opacity', String(c.vortex));
      speedsEl.style.setProperty('--st-edge-opacity',   String(c.edge));
      speedsEl.style.setProperty('--st-blur-opacity',   String(c.blur));

      speedsEl.querySelectorAll('.smelu-st-level').forEach(function (b) {
        var on = (+b.dataset.speed) === level;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      stDesc.classList.add('is-swapping');
      stChips.classList.add('is-swapping');
      window.setTimeout(function () {
        stDesc.textContent = c.desc;
        stChips.innerHTML = c.chips.map(function (t) { return '<li>' + t + '</li>'; }).join('');
        stRpm.textContent = c.rpm;
        stDesc.classList.remove('is-swapping');
        stChips.classList.remove('is-swapping');
      }, 170);
    }

    speedsEl.querySelectorAll('.smelu-st-level').forEach(function (btn) {
      btn.addEventListener('click', function () { setSpeed(+btn.dataset.speed); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.target && e.target.closest && e.target.closest('input, textarea, [contenteditable]')) return;
      if (e.key === '1' || e.key === '2' || e.key === '3') {
        var rect = speedsEl.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) setSpeed(+e.key);
      }
    });

    setSpeed(3);
  }
})();


/* ---------------------------------------- */

/* Smooth-Anchor Handler für PDP↔Funnel Navigation. Lenis-aware.
   Sonderfälle:
     · data-smooth-to-top  → scrollt komplett nach oben (window 0)
     · scroll-margin-top 0 → Target-Top = Viewport-Top
   Sonst: liest scroll-margin-top vom Target, Fallback 96px. */
(function () {
  if (window.__smeluPdpAnchorBound === '1') return;
  window.__smeluPdpAnchorBound = '1';

  var SELECTOR = 'a[data-smooth-anchor][href*="#"]';
  var HEADER_OFFSET_FALLBACK = 96;
  /* IDs deren scroll-margin-top auch bei 0 respektiert wird */
  var MANAGED_IDS = ['smelu-fr-funnel', 'smelu-sw-funnel', 'smelu-os-funnel', 'smelu-au-funnel', 'smelu-kb-funnel', 'smelu-tb-funnel', 'kaufen'];

  function getOffset(target) {
    var cs = window.getComputedStyle(target);
    var smtRaw = cs.scrollMarginTop || '0px';
    var smt = parseFloat(smtRaw);
    if (MANAGED_IDS.indexOf(target.id) !== -1) return smt;
    if (smt > 0) return smt;
    return HEADER_OFFSET_FALLBACK;
  }

  function scrollToTop() {
    var anim = window.__smeluAnim;
    if (anim && anim.lenis && typeof anim.lenis.scrollTo === 'function') {
      anim.lenis.scrollTo(0, { duration: 1.2 });
      return;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function smoothTo(target) {
    var offset = getOffset(target);
    var anim = window.__smeluAnim;
    if (anim && anim.lenis && typeof anim.lenis.scrollTo === 'function') {
      anim.lenis.scrollTo(target, { offset: -offset, duration: 1.1 });
      return;
    }
    var rect = target.getBoundingClientRect();
    var top = rect.top + window.pageYOffset - offset;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function bindOne(btn) {
    if (btn.dataset.smeluFunnelBound === '1') return;
    btn.dataset.smeluFunnelBound = '1';
    btn.addEventListener('click', function (e) {
      /* Sonderfall: komplett nach oben (data-Attribut oder href=#top) */
      if (btn.hasAttribute('data-smooth-to-top')) {
        e.preventDefault();
        scrollToTop();
        if (history.pushState) history.pushState(null, '', window.location.pathname);
        return;
      }
      var href = btn.getAttribute('href') || '';
      var hashIdx = href.indexOf('#');
      if (hashIdx === -1) return;
      var id = href.slice(hashIdx + 1);
      if (!id || id === 'top') {
        e.preventDefault();
        scrollToTop();
        if (history.pushState) history.pushState(null, '', window.location.pathname);
        return;
      }
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      smoothTo(target);
      if (history.pushState) history.pushState(null, '', '#' + id);
    });
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(bindOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Late re-bind nach Lenis-Load (lädt async via smelu-animations.js)
     + Sicherheitsnetz für nachträglich injizierte Buttons */
  setTimeout(init, 600);
  setTimeout(init, 1600);
})();
